import ApiService from '../../services/api.service';

export default {
  namespaced: true,
  state: {
    answers: {},
    isLoading: true,
    existingAssessment: {},
    excludedAttributes: [
      'archived',
      'archived_at',
      'created_at',
      'created_by',
      'dealer_id',
      'id',
      'last_updated_by',
      'updated_at',
      'uuid',
    ],
    attributeMappings: {
      q1_s1: 'q1_s1',
      q1_s1_followup_negative: 'q1_s1_followup_negative',
      q1_s2: 'q1_s2',
      q1_s2_followup_negative: 'q1_s2_followup_negative',
      q1_s3: 'q1_s3',
      q1_s3_followup_negative: 'q1_s3_followup_negative',
      q1_s4: 'q1_s4',
      q1_s4_followup_negative: 'q1_s4_followup_negative',
      q1_s5: 'q1_s5',
      q1_s5_followup_negative: 'q1_s5_followup_negative',
      q1_s6: 'q1_s6',
      q1_s7: 'q1_s7',
      q1_s7_followup_negative: 'q1_s7_followup_negative',
      q1_s8: 'q1_s7_followup',
      q2_s1: 'q2_s1',
      q2_s2: 'q2_s1_followup',
      q2_s3: 'q2_s3',
      q2_s4: 'q2_s4',
      q2_s5: 'q2_s5',
    },
  },

  mutations: {
    SET_ANSWER(state, { key, value }) {
      state.answers = {
        ...state.answers,
        [key]: value,
      };
      console.log('key', key);
    },
    SET_LOADING(state, isLoading) {
      state.isLoading = isLoading;
    },
    RESET_ANSWERS(state) {
      state.answers = {};
    },
    SET_ANSWERS(state, answers) {
      state.answers = answers;
    },
    SET_EXISTING_ASSESSMENT(state, value) {
      state.existingAssessment = value;
    },
  },

  actions: {
    updateAnswer({ commit }, { id, value }) {
      commit('SET_ANSWER', { key: id, value });
    },

    async checkExistingAssessment({ commit, dispatch }, currentDealership) {
      let params = {
        'q[dealer_id_eq]': currentDealership.id,
        'q[s]': 'created_at desc',
      };

      await ApiService.query('repair_order_assessments', { params }).then(
        (response) => {
          if (response.data && response.data.length > 0) {
            commit('SET_EXISTING_ASSESSMENT', response.data[0]);
            dispatch('updateAssessmentAnswers');
          } else {
            commit('SET_EXISTING_ASSESSMENT', null);
            commit('RESET_ANSWERS', null);
            commit('SET_LOADING', false);
          }
        }
      );
    },

    async submitAssessment({ state, dispatch }, currentDealership) {
      // Check if we have an existing assessment we can update
      if (state.existingAssessment) {
        // Reverse the key mappings so the backend gets the data in the expected format
        const reversedMappings = Object.fromEntries(
          Object.entries(state.attributeMappings).map(
            ([backendKey, frontendKey]) => [frontendKey, backendKey]
          )
        );

        const updatedAssessment = { ...state.existingAssessment };

        // Map values back to expected backend keys
        Object.entries(state.answers).forEach(([frontendKey, value]) => {
          const backendKey = reversedMappings[frontendKey] || frontendKey;

          let newValue = value;
          if (value === 'true') newValue = true;
          else if (value === 'false') newValue = false;

          updatedAssessment[backendKey] = newValue;
        });

        await ApiService.update(
          `repair_order_assessments`,
          updatedAssessment.id,
          {
            repair_order_assessment: updatedAssessment,
          }
        ).then(() => {
          dispatch('checkExistingAssessment', currentDealership);
        });
      }

      return state.existingAssessment;
    },

    updateAssessmentAnswers({ commit, state }) {
      // Map the existing assessment to match the expected format of the frontend answers
      const result = {};

      Object.entries(state.existingAssessment).forEach(([key, value]) => {
        if (state.excludedAttributes.includes(key)) return;

        const newKey = state.attributeMappings[key] || key;
        result[newKey] = typeof value === 'boolean' ? String(value) : value;
      });

      commit('SET_ANSWERS', result);
      commit('SET_LOADING', false);
    },
  },

  getters: {
    getAnswer: (state) => (key) => {
      const value = state.answers[key];
      return value !== undefined ? value : '';
    },
    isValid: () => () => {
      return true;
    },
  },
};
